
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom'; // Wichtig für Portale

const Overlay = ({ children, isOpen, onClose }) => {
  // Eine Ref, um den Overlay-Container zu erstellen, falls er nicht existiert
  const overlayRootRef = useRef(null);

  useEffect(() => {
    // Sicherstellen, dass der DOM-Knoten für das Portal existiert
    let overlayRoot = document.getElementById('overlay-root');
    if (!overlayRoot) {
      overlayRoot = document.createElement('div');
      overlayRoot.setAttribute('id', 'overlay-root');
      document.body.appendChild(overlayRoot);
    }
    overlayRootRef.current = overlayRoot;

    // Body-Scroll deaktivieren, wenn das Overlay geöffnet ist
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // Cleanup-Funktion für useEffect
    return () => {
      document.body.style.overflow = ''; // Scroll wieder aktivieren
      // Optional: Overlay-Root-Element entfernen, wenn es leer ist und von dieser Komponente erstellt wurde
      // if (overlayRootRef.current && !overlayRootRef.current.hasChildNodes()) {
      //   document.body.removeChild(overlayRootRef.current);
      // }
    };
  }, [isOpen]); // Abhängigkeit von isOpen, um Effekte bei Statusänderung auszuführen

  if (!isOpen) {
    return null; // Nichts rendern, wenn das Overlay nicht geöffnet ist
  }

  // createPortal rendert das Kind-Element in einem anderen DOM-Knoten
  // als dem, wo die Komponente logisch im React-Baum sitzt.
  return createPortal(
    <div
      className="overlay-backdrop"
      onClick={onClose} // Schließt das Overlay beim Klick auf den Hintergrund
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)', // Dunkler, halbtransparenter Hintergrund
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000, // Sicherstellen, dass es über allem liegt
      }}
    >
      <div
        className="overlay-content bg-white p-4 rounded shadow-lg"
        onClick={(e) => e.stopPropagation()} // Verhindert, dass Klicks auf den Inhalt das Overlay schließen
        style={{
          maxWidth: '500px',
          width: '90%', // Responsiv
          maxHeight: '90%',
          overflowY: 'auto', // Scrollbar für langen Inhalt
          position: 'relative', // Für absolute Positionierung des Schließen-Buttons
        }}
      >
        {children} {/* Hier wird der Inhalt des Overlays gerendert */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            backgroundColor: 'transparent',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            color: '#333',
          }}
        >
          &times; {/* Ein einfaches X-Symbol zum Schließen */}
        </button>
      </div>
    </div>,
    overlayRootRef.current // Rendere in das erstellte DOM-Element
  );
};

export default Overlay;